const getDefaultState = () => {
  return {
    consentement: {},
  };
};

const state = getDefaultState();

const mutations = {
  SET_CONSENTEMENT(state, cle) {
    state.consentement = { ...state.consentement, [cle]: true };
  },

  RESET_CONSENTEMENT(state, cle) {
    if (state.consentement[cle]) {
      state.consentement[cle] = null;
    }
  },

  EMPTY_CONSENTEMENT(state) {
    state.consentement = {};
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
